<template>
<v-container class="mb-4 pa-5">
    <h1 class="display-1 font-weight-bold">
      How To Stake WISE
    </h1>

    <h2 class="mt-6">How to Stake WISE</h2>
    <ol>
      <li>Go to
        <ReferrerLinkStaking />
      </li>
      <li>Connect Metamask, chose the appropriate account in MetaMask</li>
      <li>Click on "Stake WISE"</li>
      <li>Chose the "Staking Amount" and "Staking Duration"</li>
      <li>Click "STAKE WISE"</li>
      <li>Verify and confirm the transaction in Metamask</li>
    </ol>

  </v-container>
</template>

<script>

  import ReferrerLinkStaking from "@/components/ReferrerLinkStaking.vue"

export default {
    name: "HowToStakeWise",
    data() {
      return {}
    },
    components: {
      ReferrerLinkStaking
    },
  };
</script>

<style>
</style>
